// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ListSettingsModal.css';
import { Modal } from 'react-bootstrap';

// Redux
import { connect } from 'react-redux';
import { closeListSettingsModal } from '../../../actions/siteadmin/modalActions';


// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/jsonMessages';

// Component
import ListSettingsForm from '../ListSettingsForm';


class ListSettingsModal extends Component {
  static propTypes = {
    closeListSettingsModal: PropTypes.any,
    listSettingsModal: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      listSettingsModalStatus: false
    }
  }

  componentDidMount() {
    const { listSettingsModal } = this.props;
    if (listSettingsModal === true) {
      this.setState({ listSettingsModalStatus: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listSettingsModal } = nextProps;

    if (listSettingsModal === true) {
      this.setState({ listSettingsModalStatus: true });
    } else {
      this.setState({ listSettingsModalStatus: false });
    }
  }

  render() {
    const { closeListSettingsModal } = this.props;
    const { listSettingsModalStatus } = this.state;

    return (
      <Modal show={listSettingsModalStatus} onHide={closeListSettingsModal} dialogClassName='commonModalContainer globalModalContainer' >
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title className='commonModalTitle'><FormattedMessage  {...messages.carSettings} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <ListSettingsForm />
        </Modal.Body>
      </Modal>
    )
  }
}


const mapState = (state) => ({
  listSettingsModal: state.adminModalStatus.listSettingsModal,
});

const mapDispatch = {
  closeListSettingsModal,
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ListSettingsModal)));